import { css } from 'styled-components';
import { appTheme } from '../../../theme';

const mq = (target, ...conditions) => (...args) => css`
  @media ${target} and ${conditions.map(c => `(${c})`).join(' and ')} {
    ${css(...args)};
  }
`;

const mediaQuery = {
  xsmall: mq('screen', `max-width: ${appTheme.breakpoints.xsmall}px`),
  small: mq('screen', `min-width: ${appTheme.breakpoints.small}px`),
  medium: mq('screen', `min-width: ${appTheme.breakpoints.medium}px`),
  large: mq('screen', `min-width: ${appTheme.breakpoints.large}px`),
  xlarge: mq('screen', `min-width: ${appTheme.breakpoints.xlarge}px`),
};

export { mediaQuery };



// WEBPACK FOOTER //
// ./src/modules/common/util/style.js